module.exports = __webpack_public_path__ + "static/imagine-cup-99c406ff775905152dc680b7dce8c98f.jpg";